import React, { Fragment } from 'react';
import { Button, Form } from 'antd';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { FormattedMessage } from 'react-intl';
import AbstractMachine from './abstractMachine';
import userAPI from '../../../../API/user.service.api';
import {
  SUGGESTION,
  LETTER_SENT,
  PASSWORD,
} from '../../../../constants/enter.user.constants';

export default class SuggestRegistration extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = SUGGESTION;
    this._nextState = LETTER_SENT;
  }

  getTitle = () => {
    return <FormattedMessage id="Register" defaultMessage="Register" />;
  };

  isShowFreePro = () => {
    return true;
  };

  onSubmit = () => {
    this._form.validateFields().then((values) => {
      const { userEmail } = values;
      this._goTo(null, this.checkingEmail, userEmail);
    });
  };

  checkingEmail = (dispatch, userEmail) => {
    userAPI.checkUserByEmail(userEmail).then(
      (resp) => {
        if (resp.code === 200) {
          const { exist = 0, islegalon = 0 } = resp.response;
          let state = {};
          if (exist) {
            state = {
              name: PASSWORD,
              userEmail,
              isLegalOn: islegalon,
            };
          } else {
            userAPI.sendConfirmLetter(userEmail);
            state = { name: this._nextState, userEmail };
          }
          dispatch(setStateUserEnter(state));
        } else {
          const state = {
            name: this._name,
            userEmail,
            error: resp.message,
          };
          dispatch(setStateUserEnter(state));
        }
      },
      (error) => {
        dispatch(setStateUserEnter({ error })); // need to contitune!!!
      }
    );
  };

  render(props) {
    return (
      <>
        {this.getMainInput(props)}
        {this.getSecondaryInput(props)}
        <div className="unregisterMail">
          <span>
            <FormattedMessage id="Welcome" defaultMessage="Welcome" />
            &#46;
          </span>
          <br />
          <p style={{ marginBottom: '19px' }}>
            <FormattedMessage
              id="You are about to sign up to Tourstart – which we are happy about"
              defaultMessage="You are about to sign up to Tourstart – which we are happy about"
            />
            .&nbsp;
            <FormattedMessage
              id="All you need to do is to click the “Register as a new user” button"
              defaultMessage="All you need to do is to click the “Register as a new user” button"
            />
            .
          </p>
          <Form.Item className="width100" style={{ marginBottom: '18px' }}>
            <Button
              type="primary"
              className="ant-btn-primary width100"
              onClick={this.onSubmit}
            >
              <span>
                <FormattedMessage
                  id="Register as a new user"
                  defaultMessage="Register as a new user"
                />
              </span>
            </Button>
          </Form.Item>
        </div>
      </>
    );
  }
}
